export { default } from "./TermsAndPrivacyPolicy";
